import { PairType, PairTypeModule_toInt, PairTypeModule_fromInt } from "../Shared/Types.js";
import { t } from "../Lang.js";
import { Rel_addGroup, Rel_groupTypePlaceholder, Rel_groupType, Rel_groupNamePlaceholder, Rel_groupName, Rel_noGroups, Rel_groups, Rel_addFamily, Rel_members, Rel_familyNamePlaceholder, Rel_familyName, Rel_noFamilies, Rel_families, Rel_addPair, Rel_pairType, Rel_guest2, Rel_guest1, Rel_delete, Rel_noPairs, Tooltip_relationships, Rel_pairs, Rel_selectGuest, Enum_Pairtype_spouse, Enum_Pairtype_dating, Enum_Pairtype_engaged, Enum_Pairtype_partner } from "../Shared/Tr.js";
import { length, map as map_2, isEmpty, contains, tryFind, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.28.0/Option.js";
import { createElement } from "react";
import { int32ToString, stringHash, createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { collect, map as map_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { helpIcon, helpTooltip } from "./Components.js";
import { Msg } from "../App/Messages.js";
import { tryParse } from "../fable_modules/fable-library-js.4.28.0/Int32.js";
import { FSharpRef } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { join } from "../fable_modules/fable-library-js.4.28.0/String.js";

function pairTypeLabel(pt) {
    const matchValue = PairTypeModule_fromInt(pt);
    switch (matchValue.tag) {
        case 1:
            return t(Enum_Pairtype_partner);
        case 2:
            return t(Enum_Pairtype_engaged);
        case 3:
            return t(Enum_Pairtype_dating);
        default:
            return t(Enum_Pairtype_spouse);
    }
}

function pairTypeOptions() {
    return ofArray([[PairTypeModule_toInt(new PairType(0, [])), t(Enum_Pairtype_spouse)], [PairTypeModule_toInt(new PairType(1, [])), t(Enum_Pairtype_partner)], [PairTypeModule_toInt(new PairType(2, [])), t(Enum_Pairtype_engaged)], [PairTypeModule_toInt(new PairType(3, [])), t(Enum_Pairtype_dating)]]);
}

function guestName(guestId, guests) {
    return defaultArg(map((g_1) => (`${g_1.FirstName} ${g_1.LastName}`), tryFind((g) => (g.Id === guestId), guests)), "(unknown)");
}

function guestDropdown(label, guests, current, onChange) {
    let elems_1, elems;
    return createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", {
        children: label,
    }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", current], ["onChange", (ev) => {
        onChange(ev.target.value);
    }], (elems = toList(delay(() => append(singleton(createElement("option", {
        value: "",
        children: t(Rel_selectGuest),
    })), delay(() => map_1((g) => createElement("option", {
        value: g.Id,
        children: `${g.FirstName} ${g.LastName}`,
    }), guests))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function memberCheckboxList(guests, selectedIds, onToggle) {
    let elems_1;
    return createElement("div", createObj(ofArray([["className", "member-checklist"], (elems_1 = toList(delay(() => map_1((g) => {
        let elems;
        return createElement("label", createObj(ofArray([["className", "checkbox-label"], (elems = [createElement("input", {
            type: "checkbox",
            checked: contains(g.Id, selectedIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            }),
            onChange: (ev) => {
                const _arg = ev.target.checked;
                onToggle(g.Id);
            },
        }), createElement("span", {
            children: `${g.FirstName} ${g.LastName}`,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, guests))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function pairsSection(state, dispatch) {
    let elems_7;
    const form = state.PairForm;
    return createElement("div", createObj(ofArray([["className", "relationship-section"], (elems_7 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "flex items-center gap-sm mb-1"], (elems = [createElement("h4", {
            children: t(Rel_pairs),
        }), helpTooltip(t(Tooltip_relationships)), helpIcon(() => {
            dispatch(new Msg(268, ["02", "relationships"]));
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_2;
            return append(isEmpty(state.Pairs) ? singleton(createElement("p", {
                className: "text-muted text-sm",
                children: t(Rel_noPairs),
            })) : singleton(createElement("div", createObj(ofArray([["className", "relationship-list"], (elems_2 = toList(delay(() => map_1((pair) => {
                let elems_1;
                return createElement("div", createObj(ofArray([["className", "relationship-item"], (elems_1 = [createElement("span", {
                    children: `${guestName(pair.Guest1Id, state.Guests)} & ${guestName(pair.Guest2Id, state.Guests)} (${pairTypeLabel(pair.PairType)})`,
                }), createElement("button", {
                    className: "btn btn-sm btn-danger",
                    children: t(Rel_delete),
                    onClick: (_arg) => {
                        dispatch(new Msg(121, [pair.Id]));
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
            }, state.Pairs))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_6, elems_5, elems_4, elems_3;
                return singleton(createElement("div", createObj(ofArray([["className", "relationship-form mt-1"], (elems_6 = [createElement("div", createObj(ofArray([["className", "form-row"], (elems_5 = [guestDropdown(t(Rel_guest1), state.Guests, form.Guest1Id, (v) => {
                    dispatch(new Msg(116, [v]));
                }), guestDropdown(t(Rel_guest2), state.Guests, form.Guest2Id, (v_1) => {
                    dispatch(new Msg(117, [v_1]));
                }), createElement("div", createObj(ofArray([["className", "form-group"], (elems_4 = [createElement("label", {
                    children: t(Rel_pairType),
                }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", int32ToString(form.PairType)], ["onChange", (ev) => {
                    let matchValue;
                    let outArg = 0;
                    matchValue = [tryParse(ev.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_3) => {
                        outArg = (v_3 | 0);
                    })), outArg];
                    if (matchValue[0]) {
                        dispatch(new Msg(118, [matchValue[1]]));
                    }
                }], (elems_3 = toList(delay(() => collect((matchValue_1) => singleton(createElement("option", {
                    value: int32ToString(matchValue_1[0]),
                    children: matchValue_1[1],
                })), pairTypeOptions()))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("button", {
                    className: "btn btn-sm btn-primary",
                    children: t(Rel_addPair),
                    disabled: ((form.Guest1Id === "") ? true : (form.Guest2Id === "")) ? true : (form.Guest1Id === form.Guest2Id),
                    onClick: (_arg_1) => {
                        dispatch(new Msg(119, []));
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

function familiesSection(state, dispatch) {
    let elems_5;
    const form = state.FamilyForm;
    return createElement("div", createObj(ofArray([["className", "relationship-section"], (elems_5 = toList(delay(() => append(singleton(createElement("h4", {
        className: "mb-1",
        children: t(Rel_families),
    })), delay(() => {
        let elems_1;
        return append(isEmpty(state.Families) ? singleton(createElement("p", {
            className: "text-muted text-sm",
            children: t(Rel_noFamilies),
        })) : singleton(createElement("div", createObj(ofArray([["className", "relationship-list"], (elems_1 = toList(delay(() => collect((matchValue) => {
            let elems, children;
            const fam = matchValue[0];
            return singleton(createElement("div", createObj(ofArray([["className", "relationship-item"], (elems = [(children = ofArray([createElement("span", {
                className: "relationship-name",
                children: fam.Name,
            }), createElement("span", {
                className: "text-sm text-muted",
                children: join(", ", map_2((m) => guestName(m.GuestId, state.Guests), matchValue[1])),
            })]), createElement("div", {
                children: reactApi.Children.toArray(Array.from(children)),
            })), createElement("button", {
                className: "btn btn-sm btn-danger",
                children: t(Rel_delete),
                onClick: (_arg) => {
                    dispatch(new Msg(129, [fam.Id]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }, state.Families))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_4, elems_2, elems_3;
            return singleton(createElement("div", createObj(ofArray([["className", "relationship-form mt-1"], (elems_4 = [createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("label", {
                children: t(Rel_familyName),
            }), createElement("input", {
                className: "form-input",
                type: "text",
                placeholder: t(Rel_familyNamePlaceholder),
                value: form.Name,
                onChange: (ev) => {
                    dispatch(new Msg(125, [ev.target.value]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["className", "form-group"], (elems_3 = [createElement("label", {
                children: t(Rel_members),
            }), memberCheckboxList(state.Guests, form.MemberIds, (id) => {
                dispatch(new Msg(126, [id]));
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("button", {
                className: "btn btn-sm btn-primary",
                children: t(Rel_addFamily),
                disabled: (form.Name.trim() === "") ? true : (length(form.MemberIds) < 2),
                onClick: (_arg_1) => {
                    dispatch(new Msg(127, []));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function groupsSection(state, dispatch) {
    let elems_7;
    const form = state.GroupForm;
    return createElement("div", createObj(ofArray([["className", "relationship-section"], (elems_7 = toList(delay(() => append(singleton(createElement("h4", {
        className: "mb-1",
        children: t(Rel_groups),
    })), delay(() => {
        let elems_1;
        return append(isEmpty(state.Groups) ? singleton(createElement("p", {
            className: "text-muted text-sm",
            children: t(Rel_noGroups),
        })) : singleton(createElement("div", createObj(ofArray([["className", "relationship-list"], (elems_1 = toList(delay(() => collect((matchValue) => {
            let elems, children;
            const grp = matchValue[0];
            return singleton(createElement("div", createObj(ofArray([["className", "relationship-item"], (elems = [(children = ofArray([createElement("span", {
                className: "relationship-name",
                children: `${grp.Name} (${grp.GroupType})`,
            }), createElement("span", {
                className: "text-sm text-muted",
                children: join(", ", map_2((m) => guestName(m.GuestId, state.Guests), matchValue[1])),
            })]), createElement("div", {
                children: reactApi.Children.toArray(Array.from(children)),
            })), createElement("button", {
                className: "btn btn-sm btn-danger",
                children: t(Rel_delete),
                onClick: (_arg) => {
                    dispatch(new Msg(138, [grp.Id]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }, state.Groups))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_6, elems_4, elems_2, elems_3, elems_5;
            return singleton(createElement("div", createObj(ofArray([["className", "relationship-form mt-1"], (elems_6 = [createElement("div", createObj(ofArray([["className", "form-row"], (elems_4 = [createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("label", {
                children: t(Rel_groupName),
            }), createElement("input", {
                className: "form-input",
                type: "text",
                placeholder: t(Rel_groupNamePlaceholder),
                value: form.Name,
                onChange: (ev) => {
                    dispatch(new Msg(133, [ev.target.value]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["className", "form-group"], (elems_3 = [createElement("label", {
                children: t(Rel_groupType),
            }), createElement("input", {
                className: "form-input",
                type: "text",
                placeholder: t(Rel_groupTypePlaceholder),
                value: form.GroupType,
                onChange: (ev_1) => {
                    dispatch(new Msg(134, [ev_1.target.value]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["className", "form-group"], (elems_5 = [createElement("label", {
                children: t(Rel_members),
            }), memberCheckboxList(state.Guests, form.MemberIds, (id) => {
                dispatch(new Msg(135, [id]));
            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("button", {
                className: "btn btn-sm btn-primary",
                children: t(Rel_addGroup),
                disabled: ((form.Name.trim() === "") ? true : (form.GroupType.trim() === "")) ? true : (length(form.MemberIds) < 2),
                onClick: (_arg_1) => {
                    dispatch(new Msg(136, []));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

export function view(state, dispatch) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "relationships-container mt-3"], (elems = [pairsSection(state, dispatch), familiesSection(state, dispatch), groupsSection(state, dispatch)], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

